function isUndefined(obj) {
    return Object.prototype.toString.call(obj) === '[object Undefined]'
  }
  function isNumber(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]'
  }
  function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]'
  }
  
  export { isUndefined, isNumber, isObject }
  